import { atom, useRecoilState } from 'recoil';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

// 是否进来的时候打开 id mint 弹窗
const openIdMintModal = atom({
  key: 'openIdMintModal',
  default: false,
});

export const useIdMintModalOpen = () => useRecoilState(openIdMintModal);

export const useMintAndJump = () => {
  const history = useHistory();
  const [, setMintShow] = useIdMintModalOpen();

  return useCallback(() => {
    setMintShow(true);
    history.push('/settings');
  }, [history, setMintShow]);
};
